import { Component, Input } from '@angular/core';
import { CardComponent } from '../card/card.component';
import { NgForOf, NgStyle } from '@angular/common';

export interface CardData {
  title: string;
  titleColor?: string;
  subtitle?: string;
  size: number;
  sort: number;
  imgSrc?: string;
  link?: string;
  circleImgSrc?: string;
  circleSizePx?: string;
  titlePosition?: 'after' | 'below';
}

@Component({
  selector: 'app-card-list',
  imports: [CardComponent, NgForOf, NgStyle],
  templateUrl: './card-list.component.html',
  styleUrl: './card-list.component.scss',
})
export class CardListComponent {
  @Input() cards: CardData[] = [];
  @Input() columns = 3;

  getColumnStyle(size: number, sort: number) {
    return {
      'grid-column': `span ${size}`,
      order: sort,
      width: `${size * 20}vw`,
      height: `20vw`,
    };
  }

  getColumnsPerRow() {
    return {
      'grid-template-columns': `repeat(${this.columns}, auto)`,
    };
  }
}
